import { useState } from "react";
import { ChevronDown } from "lucide-react";
import Reveal from "../Reveal";

export const HOME_FAQS = [
  {
    q: "Is there a free trial?",
    a: "Yes — every plan starts with a 7-day free trial and no credit card is required. During the trial, phone number purchases, SMS, and voice calls are restricted until you pick a plan.",
  },
  {
    q: "Do I need new hardware for the business phone system?",
    a: "No. Phone numbers are provisioned inside Fieldz AI and calls work from your browser or the mobile app. Your team keeps their existing devices.",
  },
  {
    q: "Can my technicians use it in the field?",
    a: "Yes. Technicians get their own mobile portal (iOS and Android) where they see assigned jobs, navigate to addresses, update statuses, attach photos, create estimates, and collect payments.",
  },
  {
    q: "How do online payments work?",
    a: "Payments run on Stripe. You can charge cards in person, send a secure payment link by text or email, or let customers pay from their invoice online. Deposits and partial payments are supported.",
  },
  {
    q: "Can I manage multiple locations?",
    a: "Yes. Multi-location plans give you a consolidated dashboard across branches, location-based permissions for managers, per-location phone lines, and unified reporting under one subscription.",
  },
  {
    q: "Can I bring over my existing customer list?",
    a: "Yes — reach out to our team after signing up and we'll help you migrate your customers, jobs, and history into Fieldz AI.",
  },
  {
    q: "What happens after the trial ends?",
    a: "You pick the plan that fits your team and continue right where you left off. You can upgrade, downgrade, or cancel at any time from your dashboard.",
  },
  {
    q: "Is my data secure?",
    a: "All traffic is encrypted with 256-bit TLS, payments are processed by PCI-compliant Stripe (we never store card numbers), and role-based permissions control exactly what each team member can see.",
  },
];

const HomeFaq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-white py-16 md:py-24" data-testid="home-faq-section">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.22em] font-semibold text-[var(--mk-blue)] mb-4">FAQ</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 leading-[1.2]">
            Frequently asked questions
          </h2>
        </Reveal>

        <div className="space-y-3">
          {HOME_FAQS.map((faq, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={faq.q}>
                <div
                  className={`rounded-xl border transition-colors ${isOpen ? "border-blue-200 bg-blue-50/40" : "border-slate-200 bg-white"}`}
                  data-testid={`home-faq-${i}`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full flex items-center justify-between p-5 text-left"
                    data-testid={`home-faq-toggle-${i}`}
                  >
                    <span className="text-[15.5px] font-semibold text-slate-900 pr-4">{faq.q}</span>
                    <ChevronDown
                      className={`w-5 h-5 shrink-0 text-[var(--mk-blue)] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                    />
                  </button>
                  <div className="grid transition-[grid-template-rows] duration-300" style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}>
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-[14.5px] text-slate-600 leading-[1.7]">{faq.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HomeFaq;
